import { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { getUserMainAccessType } from "../lib/firebase/database";
import Loader from "./Loader";

const CourseAccessRoute = ({ children }) => {
    const { user } = useAuth();
    const [status, setStatus] = useState("checking");

    useEffect(() => {
        let cancelled = false;

        const resolveAccess = async () => {
            if (!user) {
                if (!cancelled) {
                    setStatus("forbidden");
                }
                return;
            }

            const accessType = await getUserMainAccessType(user.uid);

            if (cancelled) {
                return;
            }

            if (accessType === "course_access") {
                setStatus("allowed");
                return;
            }

            setStatus("forbidden");
        };

        resolveAccess();

        return () => {
            cancelled = true;
        };
    }, [user]);

    if (status === "checking") {
        return <Loader />;
    }

    if (status === "forbidden") {
        return <Navigate to="/formacao" replace />;
    }

    return children;
};

export default CourseAccessRoute;
